import helpers from '../../helpers';
import actionTypes from './constants';
import { DEFAULT_GOLF_OPTS } from '../../constants';

/* */
const initialState = {
  date: null,
  golf: null,
  text: null,
  players: [],
  course: null,
  activity: 1,
  accessories: {},
  accessoriesTotalQty: 0,
};

/* */
const isAnonymous = (player) => player.reference === 'UNKNOWN' && player.type === 'anonymous';

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.search.SET_ACTIVITY:
      return {
        ...state,
        activity: action.payload,
      };
    case actionTypes.search.SET_TEXT:
      return {
        ...state,
        text: action.payload,
      };
    case actionTypes.search.SET_GOLF: {
      const options = { ...DEFAULT_GOLF_OPTS, ...action.payload.options };
      return {
        ...state,
        golf: {
          ...action.payload,
          options,
        },
        date: null,
        course: null,
        accessories: {},
        accessoriesTotalQty: 0,
        players: [],
      };
    }
    case actionTypes.search.SET_DATE:
      return {
        ...state,
        date: action.payload,
      };
    case actionTypes.search.SET_COURSE:
      return {
        ...state,
        course: action.payload,
      };
    case actionTypes.search.ADD_PLAYER: {
      const { lastname: ln, firstname: fn } = action.payload;

      return {
        ...state,
        players: [
          ...state.players, {
            ...action.payload,
            lastname: ln ? ln.toUpperCase() : null,
            firstname: fn ? helpers.string.ucfirst(fn) : null,
          }],
      };
    }
    case actionTypes.search.ADJUST_PLAYERS: {
      const players = helpers.object.deepClone(state.players);
      const index = state.players.findIndex((p) => isAnonymous(p));
      if (index === -1) {
        players.splice(-1, 1);
      } else {
        players.splice(index, 1);
      }
      return {
        ...state,
        players,
      };
    }
    case actionTypes.search.REPLACE_PLAYER: {
      const { lastname: ln, firstname: fn } = action.payload;
      const players = helpers.object.deepClone(state.players);

      if (action.index === null) {
        players.some((p, i) => {
          if (p.reference === 'UNKNOWN' && p.type === 'anonymous') {
            players[i] = {
              ...action.payload,
              lastname: ln ? ln.toUpperCase() : null,
              firstname: fn ? helpers.string.ucfirst(fn) : null,
            };
            return true;
          }
          return false;
        });
      } else {
        players[action.index] = {
          ...action.payload,
          lastname: ln ? ln.toUpperCase() : null,
          firstname: fn ? helpers.string.ucfirst(fn) : null,
        };
      }
      return {
        ...state,
        players,
      };
    }
    case actionTypes.search.ADD_ACCESSORY: {
      let exists = false;
      let totalQty = 0;
      const data = helpers.object.deepClone(state.accessories);
      Object.keys(data).forEach((id) => {
        totalQty += data[id].qty;
        if (id === action.payload.id) {
          exists = true;
          data[id].qty += 1;
          totalQty += 1;
        }
      });
      if (!exists) {
        data[action.payload.id] = {
          id: action.payload.id,
          name: action.payload.name,
          qty: 1,
        };
        totalQty += 1;
      }
      return {
        ...state,
        accessories: data,
        accessoriesTotalQty: totalQty,
      };
    }
    case actionTypes.search.REMOVE_ACCESSORY: {
      let idx = null;
      let totalQty = 0;
      const lines = helpers.object.deepClone(state.accessories);
      Object.keys(lines).forEach((id) => {
        totalQty += lines[id].qty;
        if (id === action.payload.id) {
          if (lines[id].qty > 1) {
            lines[id].qty -= 1;
            totalQty -= 1;
          } else {
            idx = id;
          }
        }
      });
      if (idx !== null) {
        totalQty -= 1;
        delete lines[idx];
      }
      return {
        ...state,
        accessories: lines,
        accessoriesTotalQty: totalQty,
      };
    }
    case actionTypes.search.RESET: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
